<div class="typing-indicator">
  <div class="typing-indicator-avatar">
    <app-titan-icon [variant]="'Sparks'" [size]="'l'" class="color-orange-500"></app-titan-icon>
  </div>
  <div class="typing-indicator-content">
    <div class="typing-indicator-dots">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </div>
    <div class="typing-indicator-text">{{ text }}</div>
  </div>
</div>
